import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { usePollingEffect } from '../../../apps/professional-app/fa/common/hooks/usePollingEffect'
import { useLazyGetAllTasksQuery } from '../../../store/meetingSupport/meetingSupport'
import { selectCurrentUserEmailIntegration } from '../../../store/emailHub/emailUsers'
import { selectTaskPollingEnabled, setTasks } from '../../../store/task/task'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'

export interface EmailHubPollerProps {}

export const EmailHubPoller: React.FC<EmailHubPollerProps> = () => {
  usePollEmailThreadTasks()

  return null
}

const usePollEmailThreadTasks = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)
  const emailIntegration = useAppSelector(selectCurrentUserEmailIntegration)
  const taskPollingEnabled = useAppSelector(selectTaskPollingEnabled)

  const { threadId = null } = useParams()

  const [triggerGetTasks] = useLazyGetAllTasksQuery()

  const getTasks = useCallback(async () => {
    if (!threadId || !emailIntegration) {
      return
    }
    const { serviceId: emailConnector } = emailIntegration
    try {
      const filters = { type: 'email', emailConnector, threadId }
      const { data: tasksResponse } = await triggerGetTasks({ accountId, filters })
      if (!tasksResponse?.data) {
        return
      }
      dispatch(setTasks(tasksResponse.data))
    } catch (e) {
      console.log(e)
    }
  }, [accountId, dispatch, emailIntegration, threadId, triggerGetTasks])

  const { start: startEmailThreadTasksPolling, stop: stopEmailThreadTasksPolling } = usePollingEffect(getTasks, [], {
    interval: 5000,
  })

  useEffect(() => {
    if (taskPollingEnabled) {
      startEmailThreadTasksPolling()
    } else {
      stopEmailThreadTasksPolling()
    }
  }, [startEmailThreadTasksPolling, stopEmailThreadTasksPolling, taskPollingEnabled])
}
